<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" md="12" sm="12">
        <v-banner icon="mdi-content-copy">Request Statement Copy</v-banner>
        <v-date-picker
          v-model="date"
          color="blue darken-2"
          event-color="blue darken-2"
          header-color="primary"
          full-width
          type="month"
          class="mt-4"
          :max="max"
          :min="min"
          :landscape="$vuetify.breakpoint.lgAndUp"
        ></v-date-picker>
        <v-btn
          id="submit"
          block
          large
          outlined
          color="blue darken-2"
          class="white--text mt-4"
          @click.stop="sendStatement"
        >Get Statement</v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CopyStatement",
  data: () => {
    return {
      date: new Date().toISOString().substr(0, 7)
    };
  },
  computed: {
    ...mapGetters(["retrieveUser","retrieveSelectedCustomer"]),

    min() {
      let today = new Date();
      let past = new Date(today.getFullYear(), today.getMonth() - 11, 1);
      let month = past.getMonth();
      let year = past.getFullYear();
      return year + "-" + month;
    },
    max() {
      let today = new Date();
      let month = today.getMonth();
      month += 1;
      let year = today.getFullYear();
      return year + "-" + month;
    }
  },

  methods: {
    ...mapActions(["requestCopyStatement", "setSnackbar"]),

    sendStatement() {
      let firstDate = this.date + "-" + "01";
      let lastDate = this.getLastDay(this.date);
      if (this.isCurrentMonthYear(this.date)) {
        let today = new Date().getDate();
        lastDate = this.date + "-" + today;
      }

      console.log(this.retrieveSelectedCustomer,)

      const rec = Object.assign(
        {},
        { userId: this.retrieveUser.userNum },
        { sessionKey: this.retrieveUser.sessionKey },
        { customerNo:  this.retrieveSelectedCustomer, },
        { startDate: firstDate },
        { endDate: lastDate }
      );
      this.requestCopyStatement(rec)
        .then(response => {
          if (response.success == true) {
            this.setSnackbar({
              text: "An Email containing account statement has been sent to you"
            });
          } else {
            this.setSnackbar({ color: "error", text: response.message });
          }
        })
        .catch(er => {
          console.log(er);
        });
    },
    getLastDay(monthYearString) {
      let parts = monthYearString.split("-");
      let year = parts[0];
      let month = parts[1];
      let date = new Date(year, month, 0).getDate();
      return monthYearString + "-" + date;
    },
    isCurrentMonthYear(monthYearString) {
      let parts = monthYearString.split("-");
      let year = parts[0];
      let month = parts[1];
      let today = new Date();
      let currMonth = today.getMonth() + 1;
      let currYear = today.getFullYear();
      if (currMonth == month && currYear == year) {
        return true;
      } else {
        return false;
      }
    }
  }
  
};
</script>